import React from 'react';
import { sortBy, isEmpty } from 'lodash';
import { Link } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';

import ListItem from '@material-ui/core/ListItem';
// import CallSplitIcon from '@material-ui/icons/CallSplit';
import SwapHorizIcon from '@material-ui/icons/SwapHoriz';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import ConfirmationNumberIcon from '@material-ui/icons/ConfirmationNumber';

import ACDropDown from '../../atoms/ACDropDown';
import ACNotesDialog from '../../atoms/ACNotesDialog';
import ACPriceInputDialog from '../../atoms/ACPriceInputDialog';

import ACRoundBoxWithDotLayout from '../../atoms/ACRoundBoxWithDotLayout';

import {
  getPaymentStatusStyle,
  getActivityStatusStyle,
  getInternalBaseUrl,
  getCurrencySymbol,
  getBookingItemActivityStatuses,
  getBookingItemPaymentStatuses,
  getHumanReadableText,
} from '../../common/global';

import { getIndicatorColor } from '../../common/global';
import styles from './Stop.module.scss';
import ACButton from 'components/atoms/ACButton';
import ACTicketsDialog from 'components/atoms/ACTicketsDialog';
import { connect } from 'react-redux';
import { postBookingStopTicket } from 'components/common/actions/bookings';

class Stop extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openNotesDialog: false,
      openPriceDialog: false,
      openTicketsDialog: false,
      activity: {},
      dialogTypes: {
        ActivityStatus: 'ActivityStatus',
        Notes: 'Notes',
        Tickets: 'Tickets',
      },
      selectedDialogType: '',
      isDragging: 'false',
    };

    this.onChangeItemPaymentStatus = this.onChangeItemPaymentStatus.bind(this);
    this.onChangeItemActivityStatus = this.onChangeItemActivityStatus.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.onUpdateNotes = this.onUpdateNotes.bind(this);
    this.onUpdateItemPriceAndTax = this.onUpdateItemPriceAndTax.bind(this);
    this.onClickNotes = this.onClickNotes.bind(this);
    this.onClickPrice = this.onClickPrice.bind(this);
    this.onClickTickets = this.onClickTickets.bind(this);

    this.renderNotes = this.renderNotes.bind(this);
    this.renderTicketsDialog = this.renderTicketsDialog.bind(this);
    this.onUpdateTicketInfo = this.onUpdateTicketInfo.bind(this);
  }

  getPaymentStatuses() {
    const statuses = getBookingItemPaymentStatuses();
    let providerStatuses = statuses.filter((status) => status.showOnPlanner);
    return providerStatuses;
  }

  getActivityStauses() {
    const statuses = getBookingItemActivityStatuses();
    let providerStatuses = statuses.filter((status) => status.showOnPlanner);
    return providerStatuses;
  }

  onChangeItemPaymentStatus(event) {
    const { value = '' } = event.target;

    const itemPaymentStatuses = this.getPaymentStatuses();

    const { index } = this.props;

    const findPayment =
      itemPaymentStatuses.find((pStatus) => {
        return pStatus.name === value;
      }) || {};

    let payment = {
      status: findPayment.value,
    };
    this.props.onUpdateBookingItemPaymentFunc(index, payment);
  }

  onChangeItemActivityStatus(event) {
    const { value = '' } = event.target;
    const { dialogTypes } = this.state;

    const itemActivityStatuses = this.getActivityStauses();

    const findActivity =
      itemActivityStatuses.find((aStatus) => {
        return aStatus.name === value;
      }) || {};

    let activity = {
      status: findActivity.value,
    };

    this.setState({
      activity,
      openNotesDialog: true,
      selectedDialogType: dialogTypes.ActivityStatus,
    });
  }

  getToolTipStyle() {
    let theme = {
      overrides: {
        MuiTooltip: {
          tooltip: {
            fontSize: '16px',
            color: 'white',
            backgroundColor: '#3e424b',
            maxWidth: '300px',
            cursor: 'text',
          },
        },
      },
    };
    return createMuiTheme(theme);
  }

  onCancel() {
    this.setState({
      openNotesDialog: false,
      openPriceDialog: false,
      openTicketsDialog: false,
    });
  }

  onUpdateItemPriceAndTax(inputPrice, inputTax) {
    const { item } = this.props.stop;
    if (isEmpty(item)) return null;

    const itemId = item.id || '';
    this.setState({
      openPriceDialog: false,
    });

    let price = 0;
    let tax;
    price = inputPrice;
    tax = inputTax;

    this.props.onUpdateBookingItemPriceFunc(itemId, price, tax);
  }

  onUpdateNotes(data) {
    this.setState({
      openNotesDialog: false,
    });

    const { dialogTypes, selectedDialogType } = this.state;

    switch (selectedDialogType) {
      case dialogTypes.ActivityStatus:
        this.updateActivityNotes(data);
        break;
      case dialogTypes.Notes:
        this.updateNotes(data);
        break;
      default:
        break;
    }
  }

  updateActivityNotes(data) {
    const stopIndex = this.props.index;

    const { activity } = this.state;

    let currentNotes = this.getNotes();
    if (currentNotes && !isEmpty(currentNotes)) {
      currentNotes = '\n' + currentNotes;
    }

    let note = '';
    note = data.notes.concat(currentNotes);

    this.props.onUpdateBookingItemActivityFunc(stopIndex, activity, note);
    // this.props.onUpdateStopBookingNoteFunc(stopIndex, note);
  }

  updateNotes(data) {
    const stopIndex = this.props.index;
    let note = '';

    note = data.notes;
    this.props.onUpdateStopBookingNoteFunc(stopIndex, note);
  }

  onClickNotes() {
    const { dialogTypes } = this.state;
    this.setState({ selectedDialogType: dialogTypes.Notes, openNotesDialog: true });
  }

  onClickTickets() {
    const { dialogTypes } = this.state;
    this.setState({ selectedDialogType: dialogTypes.Tickets, openTicketsDialog: true });
  }

  onUpdateTicketInfo(data) {
    this.setState({
      openTicketsDialog: false,
    });

    // A component booking's id is shared by every booking of its package, so the
    // occasion it belongs to has to travel with it.
    this.props.postBookingStopTicketFunc(this.props.bookingId, this.props.index, {
      note: data.notes,
      files: data.files,
      removedFiles: data.removedExistingFiles,
      time: data.time,
      occasionBookingId: this.props.occasionBookingId,
    });
  }

  onClickPrice() {
    this.setState({ openPriceDialog: true });
  }

  getNotes() {
    const { stop = {} } = this.props;
    let note = '';
    if (stop.note && stop.note.private) {
      note = stop.note.private || '';
    }
    return note;
  }

  onClickBookingStop = () => {
    const { stop = {}, index } = this.props;
    stop.index = index;
    console.log('index', index);
    this.props.onSelectStopFunc(stop);
  };

  renderItemActivityStatus(activityStatus) {
    const itemActivityStatuses = this.getActivityStauses();
    let options = [];
    if (itemActivityStatuses) {
      Object.values(itemActivityStatuses).forEach((aStatus) => {
        options.push(aStatus.name);
      });
    }

    const findActivity =
      itemActivityStatuses.find((aStatus) => {
        return aStatus.value === activityStatus;
      }) || {};

    const ItemActivityStyle = getActivityStatusStyle(findActivity.value);
    return (
      <ACRoundBoxWithDotLayout
        layoutStyle={ItemActivityStyle}
        classNameOuter={styles.roundBoxWithDot}
        showDot={false}
      >
        <ACDropDown
          text={findActivity.name || ''}
          isEditable={true}
          options={options}
          selected={findActivity.name || ''}
          onChangeFunc={(e) => this.onChangeItemActivityStatus(e)}
          backgroundColor="transparent"
          color={ItemActivityStyle.color}
          isMultiple={false}
        />
      </ACRoundBoxWithDotLayout>
    );
  }

  renderItemPaymentStatus(paymentStatus, price) {
    const itemPaymentStatuses = this.getPaymentStatuses();

    let options = [];

    if (itemPaymentStatuses) {
      Object.values(itemPaymentStatuses).forEach((status) => {
        options.push(status.name);
      });
    }

    const findPayment =
      itemPaymentStatuses.find((pStatus) => {
        return pStatus.value === paymentStatus;
      }) || {};

    const paymentStatusStyle = getPaymentStatusStyle(findPayment.value || '');

    let showDot = false;

    if (paymentStatusStyle.dotColor && !isEmpty(paymentStatusStyle.dotColor)) showDot = true;

    return (
      <ACRoundBoxWithDotLayout
        layoutStyle={paymentStatusStyle}
        classNameOuter={styles.roundBoxWithDot}
        showDot={showDot}
      >
        <ACDropDown
          isEditable={true}
          options={options}
          selected={findPayment.name || ''}
          onChangeFunc={(e) => this.onChangeItemPaymentStatus(e)}
          backgroundColor="transparent"
          color={paymentStatusStyle.color}
          isMultiple={false}
        />
      </ACRoundBoxWithDotLayout>
    );
  }

  renderNotesDialog() {
    let title = '';
    let isMultiline = false;
    let areNotesCompulsory = false;
    const { dialogTypes, selectedDialogType } = this.state;
    const itemActivityStatuses = this.getActivityStauses();

    const { status } = this.state.activity;

    const findActivity =
      itemActivityStatuses.find((aStatus) => {
        return aStatus.value === status;
      }) || {};

    let notes = '';

    switch (selectedDialogType) {
      case dialogTypes.ActivityStatus:
        areNotesCompulsory = true;
        title = 'Update Activity Status: ' + findActivity.name || '';
        break;
      case dialogTypes.Notes:
        title = 'Update Notes';
        isMultiline = true;
        notes = this.getNotes();
        break;
      default:
        break;
    }
    return (
      <ACNotesDialog
        title={title}
        open={this.state.openNotesDialog}
        onClickCancelFunc={this.onCancel}
        onClickUpdateFunc={this.onUpdateNotes}
        isMultiline={isMultiline}
        notes={notes}
        areNotesCompulsory={areNotesCompulsory}
      />
    );
  }

  renderPriceInputDialog(price, taxAmount) {
    return (
      <div>
        <ACPriceInputDialog
          open={this.state.openPriceDialog}
          onClickCancelFunc={this.onCancel}
          onClickUpdateFunc={this.onUpdateItemPriceAndTax}
          price={price}
          taxAmount={taxAmount}
        />
      </div>
    );
  }

  renderTicketsDialog() {
    const { stop = {} } = this.props;
    const ticket = stop.ticket;
    const hasTicket = ticket && (ticket.info || ticket.documents?.length || ticket.time);

    return (
      <ACTicketsDialog
        title={hasTicket ? 'Update Tickets Information' : 'Add Tickets Information'}
        open={this.state.openTicketsDialog}
        ticket={ticket}
        onClickCancelFunc={this.onCancel}
        onClickUpdateFunc={this.onUpdateTicketInfo}
      />
    );
  }

  renderNotes() {
    let bookingNotesArr = [];
    let extractNotes = '';
    extractNotes = this.getNotes();
    if (!extractNotes || isEmpty(extractNotes)) {
      return null;
    } else {
      let notes = [];

      notes = extractNotes.split('\n');

      notes.forEach((note) => {
        if (note && !isEmpty(note)) {
          bookingNotesArr.push(<div key={'note-' + uuidv4()}>{note}</div>);
        }
      });
    }

    return bookingNotesArr;
  }

  renderProviderNote() {
    const { stop } = this.props;
    if (stop && stop.note && stop.note.provider) {
      return (
        <div style={{ fontStyle: 'italic', paddingTop: '5px' }}>
          Provider Note: {stop.note.provider}
        </div>
      );
    }
    return null;
  }

  onDragStopStart = (e, stopNumber) => {    
    if (!this.state.isDragging) {
      e.preventDefault();
      e.stopPropogation();
      return false;
    }
    e.dataTransfer.setData('text/plain', stopNumber - 1);
  };

  onDragStopOver = (e, stopNumber) => {
    e.preventDefault();
    this.props.highlightDestinationFunc(stopNumber);
  };

  onDropStop = (e, category, stopNumber) => {
    if (category === 'completed') {
      const from = e.dataTransfer.getData('text');
      const to = stopNumber - 1;
      this.props.onSwapCompleteFunc(from, to);
    }
  };

  onMouseDown = () => {
    this.setState({ isDragging: true });
  }

  onMouseUp = () => {
    this.setState({ isDragging: false });
  }

  render() {
    const { stop } = this.props;
    const { isDragging } = this.state;

    if (stop && stop.type && stop.type === 'payment-only' && !stop.clue) {
      stop.clue = {
        id: "payment-only-placeholder-clue",
        name: "Payment Only"
      }
    }

    // A ticket-only stop is the whole route of a booking fulfilled by tickets rather
    // than gameplay. It has no clue, and its provider is optional, so stand both in.
    const isTicketOnly = stop && stop.type === 'ticket-only';
    if (isTicketOnly) {
      if (!stop.clue) {
        stop.clue = {
          id: 'ticket-only-placeholder-clue',
          name: 'Tickets',
        };
      }
      if (!stop.provider) {
        stop.provider = { name: 'Tickets' };
      }
    }

    // The one-stop route a partner or ticketed component is seeded with at HQ sync. Like a
    // ticket-only stop it has no clue and no provider until someone picks one — but unlike
    // one it carries a real item, and recording that item's cost is the entire point of it,
    // so the price cell and its edit pencil stay.
    const isComponentStop = stop && stop.type === 'component-stop';
    if (isComponentStop) {
      const componentName = (stop.item && stop.item.name) || 'Component';
      if (!stop.clue) {
        stop.clue = {
          id: 'component-stop-placeholder-clue',
          name: componentName,
        };
      }
      if (!stop.provider) {
        stop.provider = { name: componentName };
      }
    }

    // Neither generated stop links anywhere: there is no provider record behind it yet.
    const isGeneratedStop = isTicketOnly || isComponentStop;

    if (!stop && !stop.clue) return null;

    const { clue, provider, item } = stop;
    let { type } = stop;
    let stopTypeStyles = [styles.stopType, styles.boldFont];

    if (!clue || !provider) return null;

    let itemName = '';
    if (!isEmpty(item)) itemName = item.name || '';

    const providerName = provider.name || '';
    const status = provider.status || '';

    let currencySymbol = '$';
    let price = 0;
    let priceText = '-';
    let taxAmount = 0;
    let taxAmountText = '-';
    let paymentStatus = '';
    let providerContact = '';
    let providerPhone = '';
    let providerInternalNotes = '';
    let stopNotes = '';
    let gotToProviderUrl = getInternalBaseUrl().providers + '?id=';
    let activityStatus = '';

    if (provider && !isEmpty(provider)) {
      providerContact = provider.contact || '';
      if (provider.phone && !isEmpty(provider.phone)) {
        let countryCode = provider.phone.countryCode || '';
        let number = provider.phone.number || '';
        providerPhone = countryCode.concat(number);
      }
      gotToProviderUrl += provider.id;

      if (provider.where && !isEmpty(provider.where)) {
        const { where } = provider;
        currencySymbol = getCurrencySymbol(where.country || '');
      }

      if (!isEmpty(provider.note)) {
        const { note = {} } = provider;
        providerInternalNotes = note.private || '';
      }
    }

    if (stop && item) {
      if (stop.item.payment && stop.item.payment.status) {
        paymentStatus = stop.item.payment.status;
      } else {
        if (stop.payments) {
          // FIXME: This is broken - delete this next month
          const { payments } = stop;
          const sortedPayments = sortBy(payments, ['dateTime']).reverse();
          if (sortedPayments && sortedPayments.length > 0) {
            paymentStatus = sortedPayments[0].status;
          }
        } else {
          if (provider && !isEmpty(provider)) {
            if (provider.settings) {
              paymentStatus = provider.settings.itemPaymentStatus;
            }
          }
        }
      }

      if (stop.item.activity && stop.item.activity.status) {
        activityStatus = stop.item.activity.status;
      } else {
        // FIXME: This is broken - delete this next month
        if (stop.activities) {
          const { activities } = stop;
          const sortedActivities = sortBy(activities, ['dateTime']).reverse();
          if (sortedActivities && sortedActivities.length > 0) {
            activityStatus = sortedActivities[0].status;
          }
        } else {
          if (provider && !isEmpty(provider)) {
            if (provider.settings) {
              activityStatus = provider.settings.itemActivityStatus;
            }
          }
        }
      }

      if (item.price) {
        price = item.price;
        priceText = `${currencySymbol}${item.price}`;
      }

      if (item.tax && item.tax.amount >= 0) {
        taxAmount = item.tax.amount;
        taxAmountText = `${currencySymbol}${item.tax.amount}`;
      }
      //console.log('item.tax.amount is:',item.tax.amount)
      //else {
      //  if (item.price){
      //    taxAmountText = `$0`;
      //  }
      //}
    }

    stopNotes = this.renderNotes();

    if (isEmpty(type)) {
      type = 'SET-ACTIVITY-TYPE';
      stopTypeStyles.push(styles.missingStopType);
    }

    let borderLeftStyle = `3px solid ${getIndicatorColor(status)}`;
    let stopNumber = this.props.stopNumber;

    let borderColor = '#52A8EF';
    let borderStyle = 'none';
    let padding = '0px';

    if (this.props.highlight === stopNumber) {
      borderColor = '#52A8EF';
      borderStyle = 'dashed';
      padding = '5px';
    }

    return (
      <div
        draggable={isDragging}
        className={styles.root}
        onDragStart={e => this.onDragStopStart(e, stopNumber)}
        onDragOver={e => this.onDragStopOver(e, stopNumber)}
        onDrop={e => this.onDropStop(e, 'completed', stopNumber)}
      >
        <div
          className={styles.list}
          style={{
            borderColor: borderColor,
            borderStyle: borderStyle,
            padding: padding,
          }}
        >
          <ListItem
            className={styles.root}
            style={{ backgroundColor: type === 'payment-only' ? '#BEBEBE' : '' }}
          >
            {!isGeneratedStop && (
              <div
                onMouseDown={this.onMouseDown}
                onMouseUp={this.onMouseUp}
                className={styles.extraSmallColumn}
                onClick={this.onClickBookingStop}
                style={{ width: ' 50px !important' }}
              >
                <SwapHorizIcon />
              </div>
            )}
            <div
              style={{
                width: '100%',
                display: 'flex',
                justifyItems: 'flex-start',
                alignItems: 'center',
              }}
            >
              <div className={styles.largeColumn} draggable="false">
                <Link
                  draggable="false"
                  to={isGeneratedStop ? '#' : gotToProviderUrl}
                  target={isGeneratedStop ? undefined : '_blank'}
                  onClick={isGeneratedStop ? (event) => event.preventDefault() : undefined}
                  style={{
                    textDecoration: 'none',
                    color: 'inherit',
                    cursor: isGeneratedStop ? 'default' : 'pointer',
                  }}
                >
                  <span
                    className={styles.boldFont}
                    style={{
                      borderLeft: borderLeftStyle,
                      paddingLeft: status === 'inactive' || status === 'archived' ? '5px' : '',
                    }}
                  >
                    {this.props.stop.type === 'payment-only' ? (
                      <>{providerName}</>
                    ) : (
                      <>
                        Step {this.props.stepIndex}
                        &nbsp; - &nbsp;
                        {providerName}
                      </>
                    )}
                  </span>
                  <div
                    className={stopTypeStyles.join(' ')}
                    style={{ color: type === 'payment-only' ? '#ff765f' : '' }}
                  >
                    {getHumanReadableText(type)}
                  </div>
                  <div className={styles.contact}>
                    {providerContact} &nbsp;{providerPhone ? 'Ph:' + providerPhone : ''}
                  </div>
                  <div className={styles.internalNotes}>{providerInternalNotes}</div>
                </Link>
              </div>
              <div
                className={`${styles.extraLargeColumn} ${this.props.isNotActive ? 'notActive' : null}`}
                style={{
                  padding: '10px',
                  color: `${this.props.isNotActive ? 'red' : null}`
                }}
              >
                {itemName}
                <br />
              </div>
              <div className={styles.extraLargeColumn}>
                {!isTicketOnly && this.renderItemPaymentStatus(paymentStatus, price)}
              </div>
              <div className={styles.smallColumn} style={{ display: 'flex' }}>
                <div style={{ textAlign: 'left', margin: 'auto 0px' }}>
                  <span style={{ fontWeight: 'bold', marginRight: '5px' }}>{priceText}</span>
                  {!isTicketOnly && <span>({taxAmountText})</span>}
                </div>
                {!isTicketOnly && (
                  <EditOutlinedIcon
                    style={{
                      color: '#78828a',
                      cursor: 'pointer',
                      marginLeft: 'auto',
                      marginRight: 'auto',
                    }}
                    onClick={this.onClickPrice}
                  />
                )}
              </div>
              <div className={styles.extraLargeColumn}>
                {!isTicketOnly && this.renderItemActivityStatus(activityStatus)}
              </div>
              <div className={styles.extraLargeColumn}>
                <MuiThemeProvider theme={this.getToolTipStyle()}>
                  <div
                    style={{
                      maxHeight: '50px',
                      overflow: 'hidden',
                    }}
                    className={styles.notes}
                  >
                   {stopNotes}
                  </div>
                </MuiThemeProvider>
              </div>
            </div>
            <div className={styles.extraSmallColumn} style={{ width: '30px !important' }}>
              {!isTicketOnly && (
                <EditOutlinedIcon
                  style={{
                    color: '#78828a',
                    cursor: 'pointer',
                  }}
                  onClick={this.onClickNotes}
                />
              )}
            </div>
            <div className={styles.extraLargeColumn} style={{ width: '30px !important' }}>
              {/* Gated on `isTicketOnly` and deliberately not on `isGeneratedStop`: a
                  `component-stop` is exactly where a single-stop component's ticket goes.
                  A legacy `ticket-only` stop carries its ticket already and has no item to
                  book, so it keeps no button. */}
              {!isTicketOnly && (
                <ACButton
                  text={'Tickets'}
                  iconLast={false}
                  onClickFunc={this.onClickTickets}
                  border={'#ba68c8 1px solid'}
                  backgroundColor={''}
                  color={'#ba68c8'}
                  margin="5px 5px 5px 5px"
                  padding="5px 15px"
                  disabled={false}
                  icon={<ConfirmationNumberIcon key="confirmation-icon" />}
                />
              )}
            </div>
            {this.renderNotesDialog()}
            {this.renderPriceInputDialog(price, taxAmount)}
            {this.renderProviderNote()}
            {this.renderTicketsDialog()}
          </ListItem>
        </div>
      </div>
    );
  }
}


const mapDispatchToProps = (dispatch) => {
  return {
    postBookingStopTicketFunc: (bookingId, stopNumber, data) =>
      dispatch(postBookingStopTicket(bookingId, stopNumber, data)),
  };
};

export default connect(undefined, mapDispatchToProps)(Stop);